var Form = function(){

    'use strict';

    var $ = jQuery,
    instances = [];

    function onReady() {
        $('.module.form').each(function () {
            instances.push(initInstance($(this)));
        });
    }

    function initInstance(view) {

        // Params

        var $view = view;
        var id = $view.data('id');
        var params = window.dataModules[id],
            cs = false, // Activa el custom select
            cdp = true, // Activa el custom datepicker
            cc = true, // Activa el cambio del imput de provincias
            errorOneByOne = false; // Los errores saltan uno a uno

        $view.find('script').remove();

        // Methods

        /**
         * scrollToError
         */
        function scrollToError() {
            var $firstError = $($view.find('select.error, input.error, checkbox.error').get(0));
            var $position = $firstError.offset();
            if (undefined !== $position) {
                $('html, body').animate({
                    scrollTop : $position.top - (window.innerHeight / 2) - $firstError.height()
                }, 500);
            }
        }

        function verifyForm(e) {
            var form, input, $inputs, error;

            form = $view;
            error = false;
            $inputs = form.find('input, select, textarea');
            form.find('#error').text('');

            $inputs.each(function () {
                input = $(this);

                if (errorOneByOne === false) { 
                    if (input.attr('type') === 'email') {
                        if ((input.prop('required') || input.val().length > 0) && !FormatText.testEmail(input.val())) {
                            console.log('Error 1');
                            showError(input);
                            error = true;
                        }
                    }
                    else if (input.attr('type') === 'radio' || input.attr('type') === 'checkbox') {
                        if ( form.find('input[name="' + input.attr('name') + '"]:required').prop('checked') === false ) {
                            console.log('Error 2');
                            showError(input);
                            error = true;
                        }

                    }
                    else if(input.attr('type') === 'file'){
                        if ((input.prop('required') && input.val().length < 1)) {
                            console.log('Error 3');
                            showError(input);
                            error = true;
                        }
                    }
                    else if (input.find('option').length > 0) {
                        if ((input.prop('required') && input.val() === '')) {
                            console.log('Error 4');
                            showError(input);
                            error = true;
                        }
                    }
                    else if (input.attr('type') === 'select') {
                        if ((input.prop('required') && input.val() === '')) {
                            console.log('Error 5');
                            showError(input);
                            error = true;
                        }
                    }
                    else {
                        if (input.prop('required') && !FormatText.testStandard(input.val())) {
                            console.log('Error 6');
                            console.log(input);
                            showError(input);
                            error = true;
                        }
                    }
                }
            });

            if ( !error ) {

                // Comprobamos que no sea el de alguna newsletter que se envía con ajax
                if (form.attr('id').match(/newsletter-register-form-maintenance/)) {

                    var url = "/wp-admin/admin-ajax.php";
                    var email = $("#newsletter-register-form-maintenance #email").val();
                    var post = $("#newsletter-register-form-maintenance input[name='post']").val();
                    var data = {
                        'action': 'newsletter_form_footer_maintenance',
                        'email_form': email,
                        'post': post
                    };
                    $.post(url, data, function(response) {
                        $("#newsletter-register-form-maintenance").before('<p style="text-align:center"><img src="/main-files/uploads/2017/03/success-newsletter.png"></p><p style="font-weight: 300; color: #002c67; font-size: 22px; font-family: "Open Sans", sans-serif" class="response-ajax">'+response+'</p>');
                        $("#newsletter-register-form-maintenance").html('');
                        $(".title").css('visibility', 'hidden');
                        $(".icon-title").remove();
                        $(".text").remove();

                        dataLayer.push({
                            'event': 'conversion',
                            'eAction': 'newsletter'
                        });
                    });

                    return false;
                } else if (form.attr('id').match(/newsletter-register-form-footer/)) {
                    
                    var url = "/wp-admin/admin-ajax.php";
                    var email = $("#newsletter-register-form-footer #email").val();
                    var post = $("#newsletter-register-form-footer input[name='post']").val();
                    var data = {
                        'action': 'newsletter_form_footer',
                        'email_form': email,
                        'post': post
                    };

                    $.post(url, data, function(response) {
                        $("#newsletter-register-form-footer").before('<p style="font-weight: bold; color: #002c67 !important; font-size: 14px;" class="response-ajax">' + response + '</p>');
                        $("#newsletter-register-form-footer").html('');
                        dataLayer.push({
                            'event': 'conversion',
                            'eAction': 'newsletter'
                        });
                    });

                    return false;
                } else if (form.attr('id').match(/newsletter-register-form/)) {

                    var url = "/wp-admin/admin-ajax.php";
                    var email = $("#newsletter-register-form #email").val();
                    var post = $("#newsletter-register-form input[name='post']").val();
                    var data = {
                        'action': 'newsletter_form',
                        'email_form': email,
                        'post': post
                    };

                    $.post(url, data, function(response) {
                        $("#newsletter-register-form").before('<p style="font-weight: bold; color: #002c67 !important; font-size: 14px;" class="response-ajax">' + response + '</p>');
                        $("#newsletter-register-form").html('');
                        dataLayer.push({
                            'event': 'conversion',
                            'eAction': 'newsletter'
                        });
                    });

                    return false;

                } else if (form.attr('id').match(/module-form-mailchimp/)) {

                    var url = "/wp-admin/admin-ajax.php";
                    var email =  $("#module-form-mailchimp #email-module").val();
                    var post =  $("#module-form-mailchimp input[name='post']").val();

                    var data = {
                        'action': 'newsletter_form_module',
                        'email_form': email,
                        'post': post
                    };

                    $.post(url, data, function(response) {
                        $(".newsletter-form-elements").remove();
                        $("#newsletter-module-response").html('<p>' + response + '</p>');
                        dataLayer.push({
                            'event': 'conversion',
                            'eAction': 'newsletter'
                        });
                    });

                    return false;                    

                }

                return true;

            } else {
                // scrollToError();
                return false;
            }
        }

        function showError(input) {

            input.addClass('error');

            if(input.parent('label').length > 0){

                input.parent('label').addClass('error');

            }else{

                input.parents('label').addClass('error');
                input.parent().addClass('error');

            }

            if(input.parents('form').find('#error').text() === ''){

                input.parents('form').find('#error').text(input.attr('data-error'));
                input.parents('form').find('#error').addClass('show').addClass('active');

            }

        }

        function removeError(e) {
            var $input = $(this).find('input');
            $input.removeClass('error');
            $(this).removeClass('error');
            $input.parents('form').find('div#error').html('').removeClass('show').removeClass('active');
        }

        function resetInput(e) {
            var input;
            input = $(this);
            input.removeClass('error');
            input.parents('form').find('#error').html('');
            input.parents('form').find('#error').removeClass('show').removeClass('active');
            input.parents('form').find('#error').text();
        }

        function showStateInput() {
            if (true === cc) {
                var $input = $stateSelector.find('select, input');
                var $span = $stateSelector.find('span.custom-select');
                var $newInput = $('<input type="text" data-error="' + $input.data('error') + '" class="' + $input.attr('class') + '" id="' + $input.attr('id') + '" name="' + $input.attr('name') + '" required=""/>');
                $input.remove();
                $span.remove();
                $stateSelector.append($newInput);
            }
        }

        function showStateSelect(data) {
            if (true === cc) {
                var $input = $stateSelector.find('select, input');
                var $span = $stateSelector.find('span.custom-select');
                var $newInput = $('<select data-error="' + $input.data('error') + '" class="' + $input.attr('class') + '" id="' + $input.attr('id') + '" name="' + $input.attr('name') + '" required=""></select>');
                $input.remove();
                $span.remove();
                $newInput.append(data);
                $stateSelector.append($newInput);
            }
        }

        function onCountryChange() {
            var $obj = $(this);
            var lang = $(this).val();
            lang = lang.toLocaleLowerCase();
            $.ajax({
                url: params['url'] + '?t=' + Math.random() * 1000,
                method: 'GET',
                data: {
                    lang: lang
                },
                dataType: 'html'
            })
            .done(function (data) {
                if (data === 'ERR') {
                    showStateInput();
                }
                else {
                    showStateSelect(data);
                }
            })
            .error(function (e) {
                if (e.status === 404) {
                    showStateInput();
                }
            });
        }

        // Initial functions

        $view.on('submit', verifyForm);
        $view.find('input, textarea').on('change keyup paste click', resetInput);
        $view.find('input[type="submit"]').prop('disabled', false);

        // Custom selects
        if (true === cs) {
            $view.find('select').each(function () {
                // $(this).customSelect({
                //     customClass: 'custom-select'
                // });
            });
        }

        // Custom datepicker
        if (true === cdp) {
            var date = new Date();
            $view.find('input.datepicker').datepicker({
                // changeMonth: true,
                changeYear: true,
                yearRange: "1900:" + date.getFullYear()
            });
        }

        $view.find('input[type="file"]')
        .change(function () {
            var filepath = $(this).val();
            var filename = filepath.split('\\');
            $(this).parent().find('span.custom-inputfile span.filepath').remove();
            $(this).parent().find('span.custom-inputfile').append('<span class="filepath">' + filename[filename.length - 1] + '</span>'); 
        });
        // $('.mySelectBoxClass').customSelect({customClass:'myOwnClassName'});

        // Si existen los campos de selector de pais y selector de provincia los asociamos para que cambien según el campo escogido
        var $countrySelector = $view.find('label[data-id="select-country"]');
        var $stateSelector = $view.find('label[data-id="select-state"]');
        if ( $countrySelector.length > 0 && $stateSelector.length > 0 ) {
            $countrySelector.find('select').val('ES').change(onCountryChange);
            $countrySelector.find('select').trigger('change');
        }

        function eventOffCountryChange(value) {
            cc = value;
        }

        Events.subscribe('OFF_COUNTRY_CHANGE', eventOffCountryChange);
        Events.publish('FORM_INITIALIZED', []);
    }

    $(onReady);

}

Form();
